import { useState } from "react";
import { Button } from "../button";
import { GrowGreenCalculator } from "../../utils/GrowGreenCalculator";

export const GrowGreenForm = ({ setCalculatorDataResult, language }) => {
  const [growGreenCalculatorData, setGrowGreenCalculatorData] = useState({
    alturaParede: "",
    larguraParede: "",
    temIrrigacao: false,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    const sanitizedValue = value.includes(",")
      ? value.replace(",", ".")
      : value;

    setGrowGreenCalculatorData((prevData) => ({
      ...prevData,
      [name]: sanitizedValue,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let calculator = new GrowGreenCalculator(growGreenCalculatorData);
    console.log(growGreenCalculatorData);
    console.log(calculator);

    setCalculatorDataResult(calculator);
  };

  // Objeto de tradução para os textos em diferentes idiomas
  const languageTexts = {
    "pt-br": {
      title: "Calculadora Horta Vertical Grow Green",
      alturaParedeLabel: "Altura da parede:",
      larguraParedeLabel: "Largura da parede:",
      temIrrigacaoLabel: "Tem Irrigação?",
      naoOption: "Não",
      simOption: "Sim",
      calcularButton: "Calcular",
    },
    en: {
      title: "Grow Green Vertical Garden Calculator",
      alturaParedeLabel: "Wall Height:",
      larguraParedeLabel: "Wall Width:",
      temIrrigacaoLabel: "Has Irrigation?",
      naoOption: "No",
      simOption: "Yes",
      calcularButton: "Calculate",
    },
    es: {
      title: "Calculadora de Huerto Vertical Grow Green",
      alturaParedeLabel: "Altura de la Pared:",
      larguraParedeLabel: "Ancho de la Pared:",
      temIrrigacaoLabel: "¿Tiene Riego?",
      naoOption: "No",
      simOption: "Sí",
      calcularButton: "Calcular",
    },
  };

  // Obtém os textos correspondentes à linguagem selecionada
  const texts = languageTexts[language] || languageTexts["en"]; // Se a linguagem não for encontrada, usa o inglês como padrão

  return (
    <div className="form-div">
      <h1>{texts.title}</h1>
      <form action="" id="formulario" onSubmit={handleSubmit}>
        <div className="input-container">
          <label htmlFor="alturaParede">{texts.alturaParedeLabel}</label>
          <input
            required
            name="alturaParede"
            id="alturaParede"
            type="number"
            min="0"
            step="any"
            placeholder={texts.alturaParedeLabel}
            value={growGreenCalculatorData.alturaParede}
            onChange={handleChange}
          />
        </div>
        <div className="input-container">
          <label htmlFor="larguraParede">{texts.larguraParedeLabel}</label>
          <input
            required
            name="larguraParede"
            id="larguraParede"
            type="number"
            min="0"
            step="any"
            placeholder={texts.larguraParedeLabel}
            value={growGreenCalculatorData.larguraParede}
            onChange={handleChange}
          />
        </div>
        <div className="input-container">
          <label htmlFor="temIrrigacao">{texts.temIrrigacaoLabel}</label>
          <select
            name="temIrrigacao"
            id="temIrrigacao"
            value={growGreenCalculatorData.temIrrigacao}
            onChange={handleChange}
          >
            <option value={false}>{texts.naoOption}</option>
            <option value={true}>{texts.simOption}</option>
          </select>
        </div>

        <Button
          disabled={false}
          className="btn-primary"
          text={texts.calcularButton}
        />
      </form>
    </div>
  );
};
